import React, { useEffect, useState } from 'react';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';
import { Select } from 'antd';

const mapListToOptions = (data) => {
  return data
    ?.map((item) => ({
      value: item.value,
      label: item.name,
      ...item
    }))
    .sort((a, b) => a?.label?.localeCompare(b?.label, 'vi', { sensitivity: 'base' }));
};

export const SelectParentDevice = ({
  disabled = false,
  onChange,
  value,
  parentBranch,
  parentManageGroup
}) => {
  const [options, setOptions] = useState([]);

  const handleChange = (value, option) => {
    onChange && onChange(value, option);
  };

  const fetchOptions = async (valueSearch) => {
    const response = await apiGetCategory({
      keyword: valueSearch === '' ? undefined : valueSearch,
      type: 'DHK',
      parent_level_1_id: parentManageGroup ? [parentManageGroup] : undefined,
      parent_level_2_id: parentBranch ? [parentBranch] : undefined
    });
    setOptions(mapListToOptions(response?.data?.data));
  };

  useEffect(() => {
    fetchOptions();
  }, [parentBranch, parentManageGroup]);

  const selected = options.find(({ value: itemValue }) => value === itemValue);

  return (
    <Select
      style={{ width: '100%', height: '36px' }}
      cacheOptions
      isDisabled={disabled}
      options={options}
      placeholder="Chọn Đồng hồ tổng"
      loadOptions={fetchOptions}
      value={selected}
      onChange={handleChange}
    />
  );
};
